<template>
  <div class="seminar">
    <div v-if="facility=='app'" class="content">
      <AbApp/>
    </div>
    <div v-else>
      <!-- <Banner/> -->
    </div>
  </div>
</template>

<script>
import AbApp from "./app";
export default {
  components:{
    AbApp,
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style scoped>
  .seminar,
  .app{
    height: 100%;
  }
</style>